const HeadingWithImageOtp = ({
  parentStyle,
  childStyle,
  backgroundImage,
  heading,
  paragraph,
  imageSrc,
  imageStyle,
}) => {
  return (
    <div className={parentStyle}>
      <div className={childStyle} style={{ backgroundImage: backgroundImage }}>
        <h2>{heading}</h2>
        <p>{paragraph}</p>
        <div className="text-center w-100">
          <img src={imageSrc} className={imageStyle} alt="..." />
        </div>
      </div>
    </div>
  );
};
export default HeadingWithImageOtp;
